import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { SubSink } from 'subsink';
import { Session } from '../../models/auth/session';
import { SessionService } from '../../services/auth/session.service';
import { RoleGroup } from '../../types/auth/role-group';

@Component({
  selector: 'tcat-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})
export class SideMenuComponent implements OnInit, OnDestroy {

  topMenu: typeof TOP_MENU = [];
  bottomMenu: typeof BOTTOM_MENU = [];
  subscriptions: SubSink = new SubSink();
  dashboardName?: string;

  constructor(
    private router: Router,
    private sessionService: SessionService
  ) { }

  ngOnInit(): void {

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(event => event as NavigationEnd)
      )
      .subscribe((val: NavigationEnd) => {
        const urlElements = val.urlAfterRedirects.split('/');
        let menu: any = this.topMenu.find(item => urlElements.indexOf(item.module) !== -1);
        if (menu != null) {
          this.changeMenuSelection(menu);
        } else {
          menu = this.bottomMenu.find(item => urlElements.indexOf(item.id) !== -1);
          if (menu != null) {
            this.changeMenuSelection(menu);
          }
        }
      });

    this.subscriptions.sink = this.sessionService
      .session()
      .subscribe(session => {
        this.dashboardName = session != null && session.roles != null && session.roles.length > 0 ?
          session.roles.find(role => role == RoleGroup.VENDOR_FINANCE) ? 'mis' : 'insights' : 'insights';

        this.topMenu = TOP_MENU.filter(menu => this.hasAccess(session, menu));
        this.bottomMenu = BOTTOM_MENU.filter(menu => this.hasAccess(session, menu));
      });
  }

  hasAccess(session: Session, menu: any): boolean {
    let hasAccess = (menu.roles == null || menu.roles.length === 0);
    if (!hasAccess) {
      session?.roles?.forEach(role => {
        if (menu.roles.indexOf(role) > -1) {
          hasAccess = true;
        }
      });
    }
    return hasAccess;
  }

  changeMenuSelection(menu: any) {
    this.topMenu.forEach(element => {
      element.isSelected = false;
    });
    this.bottomMenu.forEach(element => {
      element.isSelected = false;
    });
    menu.isSelected = true;
  }

  selectMenu(menu: any) {
    this.changeMenuSelection(menu);
    if (menu.id === 'logout') {
      //this.store.dispatch(GlobalActions.logout());
      this.sessionService.clearSession();
      this.router.navigateByUrl('/auth/login');
    } else if (menu.id === 'dashboard') {
      this.router.navigateByUrl(`/dashboard/${this.dashboardName}`);
    } else if (menu.route != null) {
      this.sessionService
        .session()
        .pipe(take(1))
        .subscribe(session => {
          if (this.hasAccess(session, menu)) {
            this.router.navigate([menu.route]);
          }
        });
    }
  }


  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}

const TOP_MENU = [
  {
    id: 'dashboard',
    module: 'dashboard',
    isSelected: true,
    icon: 'mdi-view-dashboard',
    route: '/dashboard',
    userType: 'VENDOR',
    roles: ['PLATFORM_ADMIN', 'CATALYCA_AGENT', 'VENDOR_AGENT', 'VENDOR_FINANCE','CATALYCA_SALES'],
    text: 'Dashboard'
  },
  {
    id: 'accounting',
    module: 'accounting',
    isSelected: false,
    icon: 'mdi-cash-multiple',
    route: '/accounting/menu',
    text: 'Accounting',
    userType: 'VENDOR',
    roles: ['VENDOR_FINANCE']
  },
  {
    id: 'companies',
    module: 'company',
    isSelected: false,
    icon: 'mdi-domain',
    route: '/company/menu',
    userType: 'VENDOR',
    roles: ['PLATFORM_ADMIN', 'CATALYCA_AGENT', 'VENDOR_FINANCE','CATALYCA_SALES'],
    text: 'Companies'
  },
  {
    id: 'requests',
    module: 'quotes',
    isSelected: false,
    icon: 'mdi-cart',
    route: '/quotes/menu',
    text: 'Travel Requests',
    userType: 'CORP',
    roles: ['PLATFORM_ADMIN', 'CATALYCA_AGENT', 'VENDOR_AGENT']
  },
  {
    id: 'messages',
    module: 'messages',
    isSelected: false,
    icon: 'mdi-message',
    route: '/messages/list',
    userType: 'VENDOR',
    roles: ['PLATFORM_ADMIN'],
    text: 'Messages'
  },
];

const BOTTOM_MENU = [
  {
    id: 'reports',
    module: 'reports',
    isSelected: false,
    icon: 'mdi-chart-bar',
    route: '/reports/menu',
    text: 'Reports',
    userType: 'VENDOR',
    roles: ['VENDOR_FINANCE', 'PLATFORM_ADMIN']
  },
  {
    id: 'settings',
    module: 'settings',
    isSelected: false,
    icon: 'mdi-cog',
    route: '/settings/menu',
    text: 'Settings',
    roles: ['PLATFORM_ADMIN', 'VENDOR_FINANCE'],
    userType: 'VENDOR',
  },
  {
    id: 'logout',
    module: 'logout',
    isSelected: false,
    icon: 'mdi-logout',
    route: '/auth/login',
    roles: [],
    text: 'Logout'
  }
];

